module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cropper"
  }, [_c('div', {
    staticClass: "lee-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "cropper-wrapper"
  }, [_c('vue-cropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.cropperOptions.img,
      "outputSize": _vm.cropperOptions.size,
      "outputType": _vm.cropperOptions.outputType,
      "info": true,
      "full": _vm.cropperOptions.full,
      "canScale": _vm.cropperOptions.canScale,
      "autoCrop": _vm.cropperOptions.autoCrop,
      "autoCropWidth": _vm.cropperOptions.autoCropWidth,
      "autoCropHeight": _vm.cropperOptions.autoCropHeight,
      "canMove": _vm.cropperOptions.canMove,
      "canMoveBox": _vm.cropperOptions.canMoveBox,
      "fixedBox": _vm.cropperOptions.fixedBox,
      "original": _vm.cropperOptions.original,
      "fixed": _vm.cropperOptions.fixed
    },
    on: {
      "realTime": _vm.realTime
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cropper-buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeImg
    }
  }, [_vm._v("ChangeImg")]), _vm._v(" "), _c('label', {
    staticClass: "el-button el-button--primary"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/png, image/jpeg, image/gif, image/jpg",
      "hidden": ""
    },
    on: {
      "change": _vm.uploadImg
    }
  }), _vm._v(" "), _c('span', [_vm._v("Upload")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.changeScale(1)
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.changeScale(-1)
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.rotateLeft
    }
  }, [_vm._v("RotateLeft")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.rotateRight
    }
  }, [_vm._v("RotateRight")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download")])], 1), _vm._v(" "), _c('div', {
    staticClass: "cropper-switches"
  }, [_c('div', {
    staticClass: "switch-item"
  }, [_c('span', [_vm._v("上传图片是否显示原始宽高(针对大图 可以铺满)")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.cropperOptions.original),
      callback: function($$v) {
        _vm.cropperOptions.original = $$v
      },
      expression: "cropperOptions.original"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "switch-item"
  }, [_c('span', [_vm._v("能否拖动图片")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.cropperOptions.canMove),
      callback: function($$v) {
        _vm.cropperOptions.canMove = $$v
      },
      expression: "cropperOptions.canMove"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "switch-item"
  }, [_c('span', [_vm._v("能否拖动截图框")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.cropperOptions.canMoveBox),
      callback: function($$v) {
        _vm.cropperOptions.canMoveBox = $$v
      },
      expression: "cropperOptions.canMoveBox"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "switch-item"
  }, [_c('span', [_vm._v("是否输出原图比例的截图")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.cropperOptions.full),
      callback: function($$v) {
        _vm.cropperOptions.full = $$v
      },
      expression: "cropperOptions.full"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "switch-item"
  }, [_c('span', [_vm._v("输出图片格式")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.cropperOptions.outputType),
      callback: function($$v) {
        _vm.cropperOptions.outputType = $$v
      },
      expression: "cropperOptions.outputType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "webp"
    }
  }, [_vm._v("webp")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "png"
    }
  }, [_vm._v("png")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "jpeg"
    }
  }, [_vm._v("jpg")])], 1)], 1)])], 1), _vm._v(" "), _c('h1', [_vm._v("result")]), _vm._v(" "), _c('div', {
    staticClass: "cropper-result",
    style: ({
      'width': _vm.preview.w + 'px',
      'height': _vm.preview.h + 'px',
      'overflow': 'hidden',
      'margin': '5px'
    })
  }, [_c('div', {
    style: (_vm.preview.div)
  }, [_c('img', {
    style: (_vm.preview.img),
    attrs: {
      "src": _vm.preview.url
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('span', {
    staticClass: "success-text"
  }, [_vm._v("Cropper")]), _vm._v(" "), _c('span', {
    staticClass: "large-text"
  }, [_vm._v("Github "), _c('a', {
    staticClass: "primary-text",
    attrs: {
      "href": "https://github.com/xyxiao001/vue-cropper"
    }
  }, [_vm._v("here")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06ea4196","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Cropper.vue
// module id = 595
// module chunks = 1